module.exports = __webpack_public_path__ + "public/img/空压机流量.7957675f.png";